import { motion } from "framer-motion";
import { PROCESS } from "@/data/site";
import { SectionHead, Reveal } from "@/components/common/Reveal";

export const Process = ({ index = "03" }) => (
  <section id="approach" className="grid-light relative bg-[#f8fafc] py-24 lg:py-32" data-testid="process-section">
    <div className="container-q">
      <SectionHead index={index} label="Our development approach" title="A clear way of working, from first call to continuous improvement."
        text="This is how we usually structure engagements. Timelines and milestones are agreed with each client once requirements are understood." />
      <ol className="relative mt-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-0">
        <motion.span aria-hidden="true" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          className="grad-line absolute left-0 right-0 top-[7px] hidden h-px origin-left lg:block" />
        {PROCESS.map((p, i) => (
          <Reveal as="li" key={p.n} delay={0.15 + i * 0.12} className="relative lg:pr-10" data-testid={`process-step-${i}`}>
            <span className="relative z-10 block h-[15px] w-[15px] rounded-[3px] border-2 border-blue-600 bg-white" />
            <p className="mt-8 font-mono text-[56px] font-medium leading-none tracking-tight text-slate-300">{p.n}</p>
            <h3 className="mt-5 text-xl font-bold tracking-tight text-slate-950">{p.title}</h3>
            <p className="mt-3 max-w-xs text-[15px] leading-relaxed text-slate-600">{p.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
